import { FormProvider } from 'react-hook-form';
import { BankAccountFormFields, BankAccountFormSchemaType } from '../../../../common';
import { useAddBankAccountForm } from './hooks';

type AddBankAccountFormPropsType = {
  onClose: () => void;
  onSubmit: (data: BankAccountFormSchemaType) => void;
};

export const AddBankAccountForm: React.FC<AddBankAccountFormPropsType> = ({
  onClose,
  onSubmit,
}) => {
  const form = useAddBankAccountForm();

  const handleSubmit = async (
    data: BankAccountFormSchemaType
  ): Promise<void> => {
    await onSubmit(data);
    onClose();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <BankAccountFormFields onClose={onClose} />
      </form>
    </FormProvider>
  );
};
